var isArray = require('./array')

/**
 * @desc value is an Array, with at least 1 value
 * @param  {*} x value
 * @return {boolean} isNotEmptyArray
 *
 * @since 4.0.0-alpha.1
 * @memberOf is
 * @func isNotEmptyArray
 *
 * @extends isArray
 * @variation && array.length !== 0
 * @see is/objWithKeys
 * @see is/array
 *
 * @example
 *  isNotEmptyArray(new Array(3))
 *  //=> true
 *  isNotEmptyArray([1, 2, 3])
 *  //=> true
 *
 *  isNotEmptyArray(new Array())
 *  //=> false
 *  isNotEmptyArray([])
 *  //=> false
 *  isNotEmptyArray(new Map())
 *  //=> false
 */
module.exports = function (x) { return isArray(x) && x.length !== 0; }

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibm90RW1wdHlBcnJheS5qcyIsInNvdXJjZXMiOlsibm90RW1wdHlBcnJheS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBpc0FycmF5ID0gcmVxdWlyZSgnLi9hcnJheScpXG5cbi8qKlxuICogQGRlc2MgdmFsdWUgaXMgYW4gQXJyYXksIHdpdGggYXQgbGVhc3QgMSB2YWx1ZVxuICogQHBhcmFtICB7Kn0geCB2YWx1ZVxuICogQHJldHVybiB7Ym9vbGVhbn0gaXNOb3RFbXB0eUFycmF5XG4gKlxuICogQHNpbmNlIDQuMC4wLWFscGhhLjFcbiAqIEBtZW1iZXJPZiBpc1xuICogQGZ1bmMgaXNOb3RFbXB0eUFycmF5XG4gKlxuICogQGV4dGVuZHMgaXNBcnJheVxuICogQHZhcmlhdGlvbiAmJiBhcnJheS5sZW5ndGggIT09IDBcbiAqIEBzZWUgaXMvb2JqV2l0aEtleXNcbiAqIEBzZWUgaXMvYXJyYXlcbiAqXG4gKiBAZXhhbXBsZVxuICogIGlzTm90RW1wdHlBcnJheShuZXcgQXJyYXkoMykpXG4gKiAgLy89PiB0cnVlXG4gKiAgaXNOb3RFbXB0eUFycmF5KFsxLCAyLCAzXSlcbiAqICAvLz0+IHRydWVcbiAqXG4gKiAgaXNOb3RFbXB0eUFycmF5KG5ldyBBcnJheSgpKVxuICogIC8vPT4gZmFsc2VcbiAqICBpc05vdEVtcHR5QXJyYXkoW10pXG4gKiAgLy89PiBmYWxzZVxuICogIGlzTm90RW1wdHlBcnJheShuZXcgTWFwKCkpXG4gKiAgLy89PiBmYWxzZVxuICovXG5tb2R1bGUuZXhwb3J0cyA9IHggPT4gaXNBcnJheSh4KSAmJiB4Lmxlbmd0aCAhPT0gMFxuIl0sIm5hbWVzIjpbImNvbnN0Il0sIm1hcHBpbmdzIjoiQUFBQUEsR0FBSyxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUMsU0FBUyxDQUFDOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQTZCbEMsTUFBTSxDQUFDLE9BQU8sR0FBRyxVQUFBLENBQUMsQ0FBQSxDQUFDLEFBQUcsU0FBQSxPQUFPLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLE1BQU0sS0FBSyxDQUFDLEdBQUE7In0=